export default "__VITE_PUBLIC_ASSET__9db2d75d__"